import {
  filterGoals,
  filterGoalsByFilterDocument,
  getWeekStartsOn,
} from '@griply/utils';
import { useSortedGoals } from 'features/goals';
import { useGoalsOverviewFilterDocument } from 'features/user';
import { useMemo } from 'react';
import { useToday } from 'shared/contexts/today';
import { useUser } from 'shared/hooks/use-user';

export const useGoalsOverviewFilteredGoals = () => {
  const user = useUser();
  const today = useToday();
  const weekStartsOn = getWeekStartsOn(user);
  const sortedGoals = useSortedGoals();
  const filterDocument = useGoalsOverviewFilterDocument();
  const showCompleted =
    user?.settings?.goalsOverview?.roadmap?.showCompletedGoals ?? true;

  return useMemo(() => {
    // Archived goals are list-only and never shown on the timeline.
    const base = filterGoals(sortedGoals, {
      hideArchived: true,
      hideCompleted: !showCompleted,
    });

    return filterGoalsByFilterDocument(base, filterDocument, {
      today,
      weekStartsOn,
    });
  }, [sortedGoals, filterDocument, showCompleted, today, weekStartsOn]);
};
